<template>
  <div class="download">
    <div class="inner">
      <div class="download_btn">
        <button @click="download" type="button">
          <div class="text">{{$t('游戲下載')}}</div>
          <div class="subtext">{{$t('windows遊戲主程式')}}</div>
        </button>
      </div>
      <div class="desc">{{$t('請點擊上方按鈕下載遊戲主程式')}}</div>
      <div class="subTitle">{{$t('执行《Karos Online》系统需求')}}</div>
      <div class="subDesc">{{$t('您的电脑可能需要达到以下配备')}}</div>
      <div class="config">
        <div class="head">
          <div class="head_col" style="width: 20%">{{$t("安裝配備")}}</div>
          <div class="head_col" style="flex: 1">{{$t('最低配备')}}</div>
          <div class="head_col" style="flex: 1">{{$t('推荐配备')}}</div>
        </div>
        <div class="row">
          <div class="label">CPU</div>
          <div class="col">Intel {{$t('Pentium 1.4GHz 以上')}}</div>
          <div class="col">Intel {{$t('Core2 Duo Dual-core Processor 以上')}}</div>
        </div>
        <div class="row">
          <div class="label">{{$t('記憶卡')}}</div>
          <div class="col">{{$t('512MB 以上')}}</div>
          <div class="col">{{$t('2 GB 以上')}}</div>
        </div>
        <div class="row">
          <div class="label">{{$t('顯示卡')}}</div>
          <div class="col">{{$t('Gefrce 8600GR 以上')}}</div>
          <div class="col">{{$t('Radeon 9000;Geforce5200 以上')}}</div>
        </div>
        <div class="row">
          <div class="label">{{$t('作業系統')}}</div>
          <div class="col">{{$t('Windows 7/10相容')}}</div>
          <div class="col">{{$t('Windows 7/10相容')}}</div>
        </div>
        <div class="row">
          <div class="label">{{$t('硬碟容量')}}</div>
          <div class="col">{{$t('5GB 以上')}}</div>
          <div class="col">{{$t('5GB 以上')}}</div>
        </div>
        <div class="row">
          <div class="label">Direct X</div>
          <div class="col">{{$t('Direct X 9.0 以上')}}</div>
          <div class="col">{{$t('Direct X 9.0 以上')}}</div>
        </div>
      </div>
    </div>
    <Dialog ref="Dialog" v-if="dialogvisible" @handleClose="close">
      {{$t('敬请期待！')}}</Dialog>
  </div>
</template>
<script>
import Dialog from "../Reservation/components/Dialog";
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      dialogvisible: false,
    };
  },
  methods: {
    showDialog() {
      this.dialogvisible = true;
    },
    close() {
      this.dialogvisible = false;
    },
    download() {
      window.open("https://cdn-karos.panggame.com/update/KarosSetup.exe");
    }
  },
};
</script>
<style lang="scss" scoped>
.download {
  box-sizing: border-box;
  padding: 40px 0;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  @media only screen and (max-width: 900px) {
    padding: 40px 0;
    font-size: 14px;
  }
  .inner {
    width: 1200px;
    margin: 0 auto;
    @media only screen and (max-width: 900px) {
      width: 90%;
    }
    .download_btn {
      width: 380px;
      height: 108px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 25px;
      @media only screen and (max-width: 900px) {
        width: 190px;
        height: 54px;
      }
      button {
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-image: url("~@/assets/img/home/btn_register.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border: none;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .text {
          font-size: 24px;
          text-align: center;
          width: 100%;
          @media only screen and (max-width: 900px) {
            font-size: 16px;
          }
        }
        .subtext {
          text-align: center;
          margin-top: 9px;
          width: 100%;
          font-size: 13px;
          letter-spacing: 2px;
          color: #fff;
          @media only screen and (max-width: 900px) {
            font-size: 14px;
          }
        }
      }
    }
    .desc {
      color: #939393;
      font-size: 16px;
      text-align: center;
      letter-spacing: 2px;
      padding-bottom: 28px;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.11);
      margin-bottom: 40px;
      @media only screen and (max-width: 900px) {
        padding-bottom: 14px;
        font-size: 14px;
        margin-bottom: 20px;
      }
    }
    .subTitle {
      color: #000000;
      font-size: 48px;
      text-align: center;
      font-weight: 100;
      @media only screen and (max-width: 900px) {
        font-size: 24px;
      }
    }
    .subDesc {
      margin: 40px 0;
      font-size: 22px;
      text-align: center;
      color: #c6a86c;
      @media only screen and (max-width: 900px) {
        margin: 20px 0;
        font-size: 14px;
      }
    }
    .config {
      margin-bottom: 40px;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
      }
      .head {
        display: flex;
        height: 60px;
        display: flex;
        align-items: center;
        background-color: #e4e6eb;
        @media only screen and (max-width: 900px) {
          height: 40px;
        }
        &_col {
          //    flex: 1;
          font-size: 18px;
          color: #09090a;
          @media only screen and (max-width: 900px) {
            font-size: 12px;
          }
        }
      }
      .row {
        display: flex;
        align-items: center;
        color: #73716f;
        font-size: 18px;
        height: 60px;
        @media only screen and (max-width: 900px) {
          font-size: 12px;
          height: 40px;
          text-align: center;
        }
        .label {
          text-align: center;
          width: 20%;
          border: 1px solid #e4e6eb;
          border-top: none;
          height: 60px;
          line-height: 60px;
          text-align: center;
          @media only screen and (max-width: 900px) {
            font-size: 12px;
            height: 40px;
            text-align: center;
            line-height: 40px;
          }
        }
        .col {
          flex: 1;
          text-align: center;
          border: 1px solid #e4e6eb;
          border-top: none;
          height: 60px;
          line-height: 60px;
          @media only screen and (max-width: 900px) {
            font-size: 12px;
            height: 40px;
            box-sizing: border-box;
            text-align: center;
            line-height: 1.5;
            padding: 0 5px;
          }
        }
      }
    }
  }
}
</style>
